import React from "react";
import faqs from "../FaqData/Faqs";
import GeneralHeader from "../components/GeneralHeader";
import SupportFaqBox from "../components/SupportFaqBox";
import SupportContactBox from "../components/SupportContactBox";
import Footer from "../components/Footer";

export default function Support() {
  return (
    <>
      {/* Hero Section Start */}
      <GeneralHeader
        heading="SUPPORT"
        tagline="Our Commitment in Hotel Reservation Excellence."
        backgroundImg="/images/support-hero-img.jpg"
      />
      {/* Hero Section End */}

      {/* FAQs Section Start */}
      <div
        className="container-fluid p-0 support-faqs"
        id="support-faq-section"
      >
        <div className="row app-container">
          <div className="col-12 p-0 search-for-places-heading">
            <h2 className="text-sm-start text-center mb-1 faq-heading">
              Frequently Asked Questions
            </h2>
          </div>
          <div
            className="col-12 p-0 accordion accordion-flush"
            id="faqAccordion"
          >
            {faqs.map((faq, index) => {
              return (
                <SupportFaqBox
                  key={index}
                  question={faq.question}
                  answer={faq.answer}
                  faqId={`index${index}`}
                />
              );
            })}
          </div>
        </div>
      </div>
      {/* FAQs Section End */}

      {/* Contact and Support Details Start */}
      <div className="container-fluid p-0 support-contact">
        <div className="row app-container gap-3">
          <SupportContactBox
            title="Any More Questions?"
            text="We are here to answer you."
            link="askQuestion"
            linkText="Ask Now"
          />
          <SupportContactBox
            title="Give Your Feedback"
            text="We value your input. Let us know!"
            link="feedback"
            linkText="Write Feedback"
          />
          <SupportContactBox
            title="Cancel Your Booking"
            text="Cancel your reservation effortlessly"
            link="cancelBooking"
            linkText="Wanna Cancel?"
          />
        </div>
      </div>
      {/* Contact and Support Details End */}

      {/* Footer Start */}
      <Footer />
      {/* Footer End */}
    </>
  );
}
